// extracted by mini-css-extract-plugin
export var buttonWrapper = "CookiePopup-module--buttonWrapper--2f525";
export var innerWrapper = "CookiePopup-module--innerWrapper--c222d";
export var message = "CookiePopup-module--message--50021";
export var wrapper = "CookiePopup-module--wrapper--1dc81";